import icon from "../../assets/coverage.svg";
import type { Property } from "../../types";

export const wifiCoverage: Property = {
  id: "coverage",
  title: "coverage.title",
  icon,
};
